import React from "react"
import SEO from "../components/SEO"

const Privacy: React.FC = () => {
  return (
    <>
      <SEO
        title="Privacy Policy | Thecodebazaar"
        description="Privacy Policy of Thecodebazaar.com explaining how we collect, use, and protect user information."
      />

      {/* Hero */}
      <section className="bg-gradient-to-br from-sky-50 to-blue-50 py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900">
            Privacy Policy
          </h1>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
            Your privacy is important to us. This Privacy Policy explains how
            Thecodebazaar.com collects, uses, and protects your information.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="container mx-auto px-4 py-14">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm border border-gray-200 p-6 sm:p-10">

          <p className="text-sm text-gray-500 mb-10">
            Last updated: January 2026
          </p>

          <div className="space-y-12 text-gray-700 leading-relaxed">

            {/* 1 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                1. Introduction
              </h2>
              <p>
                Thecodebazaar.com is committed to protecting your privacy. This
                policy applies to all visitors, users, and customers who access
                our website or purchase our digital products and services.
              </p>
            </div>

            {/* 2 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                2. Information We Collect
              </h2>
              <p className="mb-3">
                We may collect the following types of information:
              </p>
              <ul className="list-disc list-inside space-y-2">
                <li>Personal information such as name, email address, and phone number</li>
                <li>Billing or payment-related details (processed securely via third-party gateways)</li>
                <li>Website usage data such as pages visited, browser type, and IP address</li>
                <li>Communication data when you contact us via email or WhatsApp</li>
              </ul>
            </div>

            {/* 3 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                3. How We Use Your Information
              </h2>
              <ul className="list-disc list-inside space-y-2">
                <li>To deliver purchased themes, digital products, or services</li>
                <li>To communicate with you regarding orders, support, or updates</li>
                <li>To improve our website, products, and user experience</li>
                <li>To comply with legal or regulatory requirements</li>
              </ul>
            </div>

            {/* 4 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                4. Cookies & Tracking Technologies
              </h2>
              <p>
                We may use cookies and similar technologies to enhance your
                browsing experience, analyze website traffic, and understand
                user behavior. You can disable cookies through your browser
                settings if you prefer.
              </p>
            </div>

            {/* 5 */}
            <div className="bg-sky-50 border border-sky-100 rounded-xl p-6">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                5. Data Sharing & Disclosure
              </h2>
              <p className="mb-4">
                We do not sell or rent your personal information to third
                parties. Your data may only be shared:
              </p>
              <ul className="list-disc list-inside space-y-2">
                <li>With trusted third-party service providers (payment gateways, email services)</li>
                <li>When required by law or legal authorities</li>
                <li>To protect our legal rights or prevent fraud</li>
              </ul>
            </div>

            {/* 6 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                6. Data Security
              </h2>
              <p>
                We implement reasonable technical and organizational security
                measures to protect your information. However, no online
                transmission or storage method is 100% secure.
              </p>
            </div>

            {/* 7 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                7. Third-Party Links
              </h2>
              <p>
                Our website may contain links to third-party websites. We are
                not responsible for the privacy practices or content of those
                external sites.
              </p>
            </div>

            {/* 8 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                8. Children’s Privacy
              </h2>
              <p>
                Thecodebazaar.com does not knowingly collect personal
                information from children under the age of 13. If you believe
                a child has provided us with personal data, please contact us.
              </p>
            </div>

            {/* 9 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                9. Your Rights
              </h2>
              <p>
                You have the right to request access, correction, or deletion
                of your personal information, subject to applicable laws.
              </p>
            </div>

            {/* 10 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                10. Changes to This Policy
              </h2>
              <p>
                We may update this Privacy Policy from time to time. Any
                changes will be posted on this page with an updated revision
                date.
              </p>
            </div>

            {/* 11 */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                11. Contact Us
              </h2>
              <p>
                If you have any questions or concerns about this Privacy
                Policy, please contact us through the official contact details
                available on Thecodebazaar.com.
              </p>
            </div>

          </div>
        </div>
      </section>
    </>
  )
}

export default Privacy
